import {AuthGuard} from '../router-guards'
export default [{
        path: 'post/',
        component: () => import( /* webpackChunkName: "create" */ '../../components/create/create-post.vue'),
        meta: { noBottombarsMobile: true, primaryOnMobile: true, genericMobilebar: true, genericMobilebarTitle: 'Create post'},
        beforeEnter: AuthGuard
    },
]